import { render, staticRenderFns } from "./SalonServiceBox.vue?vue&type=template&id=3308fc3b&scoped=true&"
import script from "./SalonServiceBox.vue?vue&type=script&lang=js&"
export * from "./SalonServiceBox.vue?vue&type=script&lang=js&"
import style0 from "./SalonServiceBox.vue?vue&type=style&index=0&id=3308fc3b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3308fc3b",
  null
  
)

export default component.exports